import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import store from "app/redux/store/store";
import { tratamentoErroPadrao } from "app/use-cases/tratamentoErroPadrao";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { DadosFichaFinanceira, FichaFinanceiraCliente } from "./FichaFinanceiraCliente";

export type FichaFinanceiraClienteContainerProps = {
    codigoCliente: number
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
}

export const FichaFinanceiraClienteContainer = (props: FichaFinanceiraClienteContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);
    const [fichasFinanceiras, setFichasFinanceiras] = useState<DadosFichaFinanceira>();

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
   
    const recuperarDadosFichaFinanceira = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Cliente.obterDadosFichaFinanceira({ CodigoCliente: props.codigoCliente });
            setFichasFinanceiras(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e)
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Ficha Financeira", () => { })
        recuperarDadosFichaFinanceira();
    }, [])

    return (
        <>
            <Breadcrumb2Container
               passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                id="FichaFinanceiraClienteBreadcrumb"
            />
            <FichaFinanceiraCliente
                dadosFichaFinanceira={fichasFinanceiras}
                cpfCnpj={orcamento.Cliente.CpfCnpj}
                nome={orcamento.Cliente.Nome}
            />
        </>
    )
}